window.AmbitionRuntime.register('page-motion', context => {
  const page = document.querySelector('.ambition-page');
  if (!page || page.dataset.pageMotionReady) return;
  page.dataset.pageMotionReady = 'true';
  const editing = Boolean(window.Shopify?.designMode);
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const active = new Map();
  const recipes = new Map();
  const ease = 'cubic-bezier(.18,.72,.22,1)';
  let started = false;
  let parallaxFrame = 0;
  const parallaxVisible = new Set();

  const frames = {
    text: { opacity: [0, 1], transform: ['translateY(22px)', 'translateY(0)'] },
    small: { opacity: [0, 1], transform: ['translateY(12px)', 'translateY(0)'] },
    editorial: { opacity: [0, 1], transform: ['translateX(-32px)', 'translateX(0)'] },
    image: { opacity: [0, 1], transform: ['translateY(28px) scale(.985)', 'translateY(0) scale(1)'] },
    banner: { opacity: [0, 1], transform: ['translateY(26px)', 'translateY(0)'] },
    film: { opacity: [.2, 1], clipPath: ['inset(14% 0 14% 0)', 'inset(0 0 0 0)'], transform: ['translateY(24px)', 'translateY(0)'] },
    accessory: { opacity: [.1, 1], clipPath: ['inset(10% 0 10% 0)', 'inset(0 0 0 0)'], transform: ['translateY(26px)', 'translateY(0)'] },
    header: { opacity: [0, 1], transform: ['translateY(-12px)', 'translateY(0)'] }
  };
  function settle(element) {
    if (!element) return;
    const animation = active.get(element);
    if (animation) {
      animation.cancel();
      active.delete(element);
    }
    element.dataset.pageMotionState = 'shown';
    observer?.unobserve(element);
  }
  function play(element, recipe = {}) {
    if (!element || element.dataset.pageMotionState === 'shown') return;
    const style = getComputedStyle(element);
    if (style.display === 'none') { element.dataset.pageMotionState = 'shown'; return; }
    if (editing || context.signal.aborted || motion.matches || document.hidden || typeof element.animate !== 'function') { settle(element); return; }
    const key = recipe.kind || 'text';
    element.dataset.pageMotionState = 'entering';
    const animation = element.animate(frames[key], {
      duration: recipe.duration || 720,
      delay: recipe.delay || 0,
      easing: ease,
      fill: 'both'
    });
    active.set(element, animation);
    const finish = () => {
      if (active.get(element) !== animation) return;
      element.dataset.pageMotionState = 'shown';
      active.delete(element);
      animation.cancel();
    };
    animation.finished.then(finish, () => {});
    observer?.unobserve(element);
    if (recipe.after) recipe.after();
  }
  const observer = typeof IntersectionObserver === 'function' ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting && started) play(entry.target, recipes.get(entry.target));
    });
  }, { threshold: .01, rootMargin: '0px' }) : null;

  function register(element, recipe) {
    if (!element) return;
    recipes.set(element, recipe);
    element.dataset.pageMotionKind = recipe.kind;
    const box = element.getBoundingClientRect();
    if (editing || motion.matches || !observer || box.bottom < 0) {
      element.dataset.pageMotionState = 'shown';
      return;
    }
    element.dataset.pageMotionState = 'waiting';
  }
  function revealContext(node) {
    if (!(node instanceof Element)) return;
    for (const element of recipes.keys()) {
      if (element.contains(node) || node.contains(element)) settle(element);
    }
    [...active.keys()].forEach(element => {
      if (element.contains(node) || node.contains(element)) settle(element);
    });
  }
  function showAll() {
    for (const element of recipes.keys()) settle(element);
    [...active.keys()].forEach(settle);
    cancelAnimationFrame(parallaxFrame);
    parallaxFrame = 0;
    page.querySelectorAll('.story-art img').forEach(image => { image.style.translate = ''; });
  }
  function parallax() {
    parallaxFrame = 0;
    if (editing || context.signal.aborted || motion.matches || document.hidden) return;
    const positions = [...parallaxVisible].map(element => {
      const box = element.getBoundingClientRect();
      const progress = Math.max(0, Math.min(1, (innerHeight - box.top) / (innerHeight + box.height)));
      return [element.querySelector('img'), (progress - .5) * 24];
    });
    positions.forEach(([image, y]) => { if (image) image.style.translate = `0 ${y.toFixed(2)}px`; });
  }
  function requestParallax() {
    if (!editing && !context.signal.aborted && started && parallaxVisible.size && !motion.matches && !document.hidden && !parallaxFrame) parallaxFrame = requestAnimationFrame(parallax);
  }
  const parallaxObserver = typeof IntersectionObserver === 'function' ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) parallaxVisible.add(entry.target);
      else parallaxVisible.delete(entry.target);
    });
    requestParallax();
  }) : null;
  function collectionCards(windowElement) {
    if (!windowElement) return;
    const viewport = windowElement.getBoundingClientRect();
    const cards = [...windowElement.querySelectorAll('.loop-track article')].filter(card => {
      const box = card.getBoundingClientRect();
      return box.right > viewport.left && box.left < viewport.right;
    });
    cards.forEach((card, index) => {
      for (const [offset, selector] of ['picture', 'h3', 'p'].entries()) {
        const element = card.querySelector(selector);
        play(element, { kind: offset ? 'small' : 'image', duration: 650, delay: Math.min(index * 75 + offset * 55, 350) });
      }
    });
  }
  function opening() {
    if (editing || context.signal.aborted || scrollY > 80 || motion.matches) return;
    page.querySelectorAll('.ambition-header:not([data-ambition-dock]) nav > a').forEach((element, index) => play(element, { kind: 'header', duration: 650, delay: index * 70 }));
  }
  function start() {
    if (started || context.signal.aborted) return;
    started = true;
    if (editing || motion.matches) { showAll(); return; }
    for (const element of recipes.keys()) {
      if (element.dataset.pageMotionState === 'shown') continue;
      const box = element.getBoundingClientRect();
      if (box.bottom < 0) settle(element);
      else if (box.top < innerHeight && box.bottom > 0) play(element, recipes.get(element));
      else observer?.observe(element);
    }
    page.querySelectorAll('.story-art').forEach(element => parallaxObserver?.observe(element));
    requestParallax();
  }

  context.cleanup(() => {
    showAll();
    observer?.disconnect(); parallaxObserver?.disconnect();
    parallaxVisible.clear();
    recipes.forEach((_, element) => { delete element.dataset.pageMotionState; delete element.dataset.pageMotionKind; });
    recipes.clear(); active.clear();
    delete page.dataset.pageMotionReady;
  });

  try {
    page.querySelectorAll('.film > picture, .film > .ambition-video').forEach(element => {
      if (element.closest('.film.has-cinema')) return;
      register(element, { kind: 'film', duration: 1000 });
    });
    page.querySelectorAll('.story').forEach(story => {
      register(story.querySelector('.story-art'), { kind: 'banner', duration: 950 });
      register(story.querySelector('.signature'), { kind: 'text', duration: 750, delay: 90 });
      register(story.querySelector('.story-tagline'), { kind: 'small', duration: 650, delay: 180 });
    });
    page.querySelectorAll('.product').forEach(product => {
      register(product.querySelector('.editorial'), { kind: 'editorial', duration: 950 });
      register(product.querySelector('.product-copy'), { kind: 'text', duration: 750 });
      register(product.querySelector('.product-image'), { kind: 'image', duration: 850, delay: 80 });
      register(product.querySelector('.colors'), { kind: 'small', duration: 650, delay: 100 });
      register(product.querySelector('.details > .cta'), { kind: 'small', duration: 650, delay: 150 });
    });
    page.querySelectorAll('.accessories > div').forEach((panel, index) => {
      register(panel.querySelector('picture'), { kind: 'accessory', duration: 950, delay: index * 80 });
      register(panel.querySelector('h2'), { kind: 'small', duration: 650, delay: 120 });
    });
    page.querySelectorAll('.loop-window').forEach(element => register(element, { kind: 'image', duration: 800, after: () => collectionCards(element) }));
    document.querySelectorAll('#rn-footer .rn-footer__newsletter, #rn-footer .rn-footer__vip, #rn-footer .rn-footer__nav, #rn-footer .rn-footer__legal, #rn-footer .rn-footer__social').forEach((element, index) => {
      register(element, { kind: 'text', duration: 750, delay: index > 1 ? (index % 3) * 80 : 0 });
    });
    context.listen(document, 'focusin', event => revealContext(event.target));
    context.listen(window, 'scroll', requestParallax, { passive: true });
    context.listen(window, 'resize', requestParallax);
    context.listen(window, 'hashchange', () => {
      const id = decodeURIComponent(location.hash.slice(1));
      if (id) revealContext(document.getElementById(id));
    });
    context.listen(document, 'visibilitychange', () => {
      if (document.hidden) {
        active.forEach((_, element) => settle(element));
        cancelAnimationFrame(parallaxFrame);
        parallaxFrame = 0;
      } else requestParallax();
    });
    context.listen(motion, 'change', () => { if (motion.matches) showAll(); });
    context.listen(window, 'pageshow', event => { if (event.persisted) { active.forEach((_, element) => settle(element)); start(); } });
    let opened = false;
    const openOnce = () => { if (!opened) { opened = true; opening(); } };
    context.listen(document, 'ambition:reveal', openOnce, { once: true });
    if (window.AmbitionLoading?.ready) {
      if (['revealing', 'ready'].includes(window.AmbitionLoading.phase)) openOnce();
      window.AmbitionLoading.ready.then(() => { openOnce(); start(); });
    } else { openOnce(); start(); }
  } catch (error) {
    showAll();
    throw error;
  }
});

window.AmbitionRuntime.register('hero-intro', context => {
  const page = document.querySelector('.ambition-page');
  const hero = page?.querySelector('.hero');
  if (!hero) return;
  const art = hero.querySelector('.hero-art img');
  const wordmark = hero.querySelector('[data-hero-wordmark]');
  const logo = wordmark?.querySelector('picture') || hero.querySelector('.hero-heading h1 picture');
  const strokes = [...(wordmark?.querySelectorAll('[data-wordmark-stroke]') || [])];
  const tagline = hero.querySelector('.hero-heading > p');
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const animations = new Set();
  const navigation = performance.getEntriesByType('navigation')[0];
  let finished = false, started = false;

  function finish() {
    finished = true;
    page.dataset.heroIntroPlayed = 'true';
    animations.forEach(animation => animation.cancel());
    animations.clear();
    wordmark?.removeAttribute('data-wordmark-drawing');
    hero.dataset.heroIntro = 'done';
  }
  function animate(element, frames, duration, delay = 0) {
    if (!element) return null;
    const animation = element.animate(frames, { duration, delay, easing: 'cubic-bezier(.22,.61,.36,1)', fill: 'both' });
    animations.add(animation);
    return animation;
  }
  function start() {
    if (started || finished || context.signal.aborted) return;
    started = true;
    if (motion.matches || document.hidden || scrollY > 80) { finish(); return; }
    hero.dataset.heroIntro = 'playing';
    page.dataset.heroIntroPlayed = 'true';
    try {
      animate(art, { opacity: [0, 1] }, 1600);
      animate(tagline, { opacity: [0, 1], transform: ['translateY(8px)', 'translateY(0)'] }, 650, 600);
      if (strokes.length) {
        strokes.forEach((stroke, index) => animate(stroke, [
          { strokeDashoffset: '100', opacity: 0, offset: 0 },
          { strokeDashoffset: '99.6', opacity: 1, offset: .01 },
          { strokeDashoffset: '0', opacity: 1, offset: 1 }
        ], 720, index * 95));
      } else {
        animate(logo, { opacity: [0, 1] }, 1000, 80);
      }
      Promise.allSettled([...animations].map(animation => animation.finished)).then(() => {
        if (!context.signal.aborted) finish();
      });
    } catch (error) {
      finish();
      throw error;
    }
  }

  context.cleanup(() => { finish(); delete hero.dataset.heroIntro; });
  context.listen(hero, 'ambition:hero-reveal', finish);
  context.listen(document, 'visibilitychange', () => { if (document.hidden) finish(); });
  context.listen(motion, 'change', () => { if (motion.matches) finish(); });
  context.listen(document, 'keydown', event => { if (['Escape', 'Tab'].includes(event.key)) finish(); });
  context.listen(window, 'pageshow', event => { if (event.persisted) finish(); });
  if (window.Shopify?.designMode || motion.matches || document.hidden || location.hash || scrollY > 80 || navigation?.type === 'back_forward' || page.dataset.heroIntroPlayed) {
    finish();
    return;
  }
  hero.dataset.heroIntro = 'waiting';
  if (strokes.length) wordmark.setAttribute('data-wordmark-drawing', '');
  if (window.AmbitionLoading?.ready) window.AmbitionLoading.ready.then(start);
  else start();
});
